import AlertProps from './type';

import Button from '../Button';
import Icon from '../Icon';
import IconButton from '../IconButton';
import { TucarTheme } from '../theme';

import {
  AlertStyled,
  ItemAlertStyled,
  HeaderAlertStyled,
  HeaderContentAlertStyled,
  BodyAlertStyled,
  BodyButtonAlertStyled,
} from './styled';

const Alert = ({ children, onClose, ...props }: AlertProps) => {
  const { variant, title, buttonProps } = props;
  const { onClick } = buttonProps || {};

  const iconAlert = () => {
    switch (variant) {
      case 'success':
        return { name: 'checkCircleRounded', color: TucarTheme.colors.green600 };
      case 'error':
        return { name: 'errorRounded', color: TucarTheme.colors.error500 };
      default:
        return { name: 'warningRounded', color: TucarTheme.colors.warning600 };
    }
  };

  return (
    <AlertStyled {...props}>
      <HeaderAlertStyled>
        <ItemAlertStyled variant={variant}>
          <Icon {...iconAlert()} />
        </ItemAlertStyled>
        <HeaderContentAlertStyled>
          <p style={TucarTheme.typography.body2}>{title}</p>
          <IconButton
            data-testid="clearButtonAlert"
            onClick={onClose}
            variant="ghost"
            iconProps={{ name: 'clearRounded', color: '#17171C', size: '24px' }}
          />
        </HeaderContentAlertStyled>
      </HeaderAlertStyled>

      <BodyAlertStyled>
        {children}

        {onClick && (
          <BodyButtonAlertStyled data-testid="actionButtonAlert">
            <Button {...buttonProps} />
          </BodyButtonAlertStyled>
        )}
      </BodyAlertStyled>
    </AlertStyled>
  );
};

export default Alert;
